// API base URL 解析（Web PWA vs Capacitor 原生 App）
//
// Web PWA：前端與 Netlify Functions 同源，相對路徑 `/.netlify/functions/*` 即可。
// Capacitor App：前端從打包的本地資源載入（capacitor://localhost / https://localhost），
//   相對路徑會打到 WebView 自身而非 Netlify → API 全掛。
//
// 解法：build 時用 VITE_API_BASE 指定 production 後端 origin。
//   - Web build：不設 → 空字串 → 維持相對同源（行為完全不變）。
//   - Capacitor build：設 VITE_API_BASE=https://<prod>.netlify.app
//     （見 runbook「Capacitor App build」；於 npm run cap:* 前 export）。
export const API_BASE = import.meta.env.VITE_API_BASE || '';

/** 把相對 API path 前綴上 API_BASE（Web 為空 → 不變；App 為 production origin）。 */
export function apiUrl(path) {
  return `${API_BASE}${path}`;
}
